let language = {
    "STORES-HEADER-BUTTON-NEW": "Add Store",
    "STORES-CONTENT-EMPTY-TIPS-1": "You don't have any Store,",
    "STORES-CONTENT-EMPTY-TIPS-2-CLICK": "Click here",
    "STORES-CONTENT-EMPTY-TIPS-3": "to add your first Store.",
    "STORES-CONTENT-SELECT-DESCRIPTION": "Select a store below to change or update settings.",
    // TABLE
    "STORES-CONTENT-TABLE-HEADER-NAME": "Store Name",
    "STORES-CONTENT-TABLE-HEADER-URL": "Store URL",
    "STORES-CONTENT-TABLE-HEADER-CONFIG-SYNC": "Configuration Synchronization",
    "STORES-CONTENT-TABLE-HEADER-STATE": "Store Status",
    "STORES-CONTENT-TABLE-HEADER-OPERATION": "Actions",
    "STORES-CONTENT-OPERATION-SETTING": "Modify",
    "STORES-CONTENT-OPERATION-SYNCHRONIZE-CURRENCY": "Synchronize Currency",
    "STORES-CONTENT-OPERATION-ORDERS": "Customer Orders",
    "STORES-CONTENT-OPERATION-PRODUCTS": "Store products",
    "STORES-CONTENT-OPERATION-EMAIL-SETTING": "Tracking Email",
    "STORES-CONTENT-OPERATION-DEFAULT-SHIPPING": "Default Shipping",
    "STORES-CONTENT-CONFIG-SYNCHRONIZING":"Synchronizing",
    // BUTTON
    "STORE-STATUS-BUTTON-ACTIVATE": "Activate",
    "STORE-STATUS-BUTTON-CLOSE": "Inactive",

    // STORE-DETAIL
    "STORES-DETAIL-BASIC-INFOMATION-TITLE": "Basic Infomation",
    "STORES-DETAIL-BASIC-INFOMATION-NAME": "Store Name :",
    "STORES-DETAIL-OTHER-INFOMATION-TITLE": "Other",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING": "Billing Address :",
    "STORES-DETAIL-OTHER-RERURN-ADDRESS": "Return Address :",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING-SELECT-ADDRESS-BUTTON": "Select Address",
    "STORES-DETAIL-OTHER-INFOMATION-BILLING-SELECT-ADDRESS-EMPTY-TIPS": "No selected billing address.",
    "STORES-DETAIL-OTHER-INFOMATION-REFUND": "Return Address :",
    "STORES-DETAIL-OTHER-INFOMATION-REFUND-SELECT-ADDRESS-EMPTY-TIPS": "No selected return address.",
    "STORES-DETAIL-FORM-BUTTON-CANCEL": "Cancel",
    "STORES-DETAIL-FORM-BUTTON-SAVE": "Save",
    "STORES-DETAIL-QP-TOKEN-INFOMATION": "Information",
    "STORES-DETAIL-QP-TOKEN-INFOMATION-TITLE": "Store Token :",
    "STORES-DETAIL-QP-TOKEN-INFOMATION-TIPS": "Store token has been copied!",
    "STORES-DETAIL-BASIC-INFOMATION-URL": "Store URL :",
    "STORES-DETAIL-BASIC-INFOMATION-URL-CLICK-TIPS": "Click to your store:",
    "STORES-DETAIL-WOO-RECONNECT": "There was an issue with your store authorization. Please reconnect your store.",
    "STORES-DETAIL-WOO-RECONNECT-BUTTON": "Reauthorize",
    "STORES-DETAIL-WOO-INFOMATION-TITLE": "WooCommerce Infomation",
    "STORES-DETAIL-WOO-INFOMATION-CONSUMER-KEY": "Consumer Key :",
    "STORES-DETAIL-WOO-INFOMATION-CONSUMER-SECRET": "Consumer Secret :",


    // modal
    "STORES-MODAL-RECONNECT-TITLE": "Try to reconnect your store.",
    "STORES-MODAL-RECONNECT-BUTTON": "reconnect",
    "STORES-MODAL-GET-TOKEN-TITLE": "Show {{storeName}} Token",
    "STORES-MODAL-GET-TOKEN-PASSWORD": "Password:",
    "STORES-MODAL-GET-TOKEN-BUTTON-CANCEL": "Cancel",
    "STORES-MODAL-GET-TOKEN-BUTTON-SUBMIT": "Submit",
    "STORES-MODAL-SHOW-SUCCESS-INFOMATION-TITLE": "Your store has been created successfully!",
    "STORES-MODAL-SHOW-SUCCESS-INFOMATION-BUTTON": "Go to stores list",

    // new store
    "STORES-SETTING-TAB-INTEGRATION": "Integration Mode",
    "STORES-SETTING-TAB-CONFIG": "Store Config",
    "STORES-SETTING-TAB-CONNECT": "Connect Your Store",
    "STORES-SETTING-API-SHOP-TITLE": "Setting Store",
    "STORES-SETTING-API-SHOP-STORE-NAME": "Store Name",
    "STORES-SETTING-API-SHOP-STORE-NAME-TIPS": "invalid name",
    "STORES-SETTING-API-SHOP-STORE-URL": "Store URL",
    "STORES-SETTING-API-SHOP-STORE-URL-TIPS": "invalid url",
    "STORES-SETTING-API-SHOP-BUTTON": "Save",
    "STORES-SETTING-SHOPIFY-SHOP-TITLE": "Connect your Shopify store to {{appName}}",
    "STORES-SETTING-SHOPIFY-SHOP-DESCRIPTION": "Follow these steps to connect your Shopify store to your {{appName}} account.",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-TITLE": "Step1: Create your Shopify account",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-1": "If you dont't have a Shopify account yet, please visit ",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-2": "and sign up for an account. ",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-3": "Disclaimer: {{appName}} may receive a commission from signups or purchases made through this link.",
    "STORES-SETTING-SHOPIFY-SHOP-STEP1-4": "Further information can be found here.",
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-TITLE": 'Step2: Install the "QPMN POD" app on Shopify',
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-1": '1.Click the below link to install',
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-BUTTON": 'Install the App',
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-2": '2.Log in to your Shopify account.',
    "STORES-SETTING-SHOPIFY-SHOP-STEP2-3": '3.Click the "QPMN POD" app.',
    "STORES-SETTING-WOOCOMMERCE-SHOP-TITLE": 'WooCommerce Information',
    "STORES-SETTING-WOOCOMMERCE-SHOP-NOTICE": 'Notice: Please make sure you have checked the "Enable the legacy REST API".',
    "STORES-SETTING-WOOCOMMERCE-SHOP-LEARN-MORE": 'learn more...',
    "STORES-SETTING-WOOCOMMERCE-SHOP-AUTHORIZATION": 'Connect by Authorization',
    "STORES-SETTING-WOOCOMMERCE-SHOP-AUTHORIZATION-BUTTON": 'Save and Go to Authorization',
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL": 'Connect by Manual Entry',
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-NOTICE": 'Notice: How to set up your online shop.',
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-BUTTON": 'See detail',
    "STORES-SETTING-WOOCOMMERCE-SHOP-CONSUMER-KEY": 'Consumer key :',
    "STORES-SETTING-WOOCOMMERCE-SHOP-CONSUMER-SECRET": 'Consumer Secret :',
    "STORES-SETTING-WOOCOMMERCE-SHOP-MANUAL-BUTTON-SAVE": 'Save and Connect to Your Store',
    "STORES-SETTING-WOOCOMMERCE-SHOP-ONLY-SAVE-TITLE": 'Only save store information but not connect',
    "STORES-SETTING-WOOCOMMERCE-SHOP-ONLY-SAVE-BUTTON": 'Save as draft',
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-TITLE": 'Setting Store',
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-NEXT": 'Next',
    "STORES-SETTING-WOOCOMMERCE-SHOP-EXIST-BUTTON": 'Save as draft',
    "STORES-SETTING-SELECT-MODE-DESCRIPTION": 'Description',
    "STORES-SETTING-SELECT-MODE-LEARN-MORE": 'Learn more',
    "STORES-SETTING-SELECT-MODE-BUTTON-CONNECT": 'Connect',
    "STORES-SETTING-SELECT-MODE-WOOCOMMERCE": 'WooCommerce / Snapshop',
    "STORES-SETTING-SELECT-MODE-WOOCOMMERCE-DESCRIPTION": `Select this option if you are using WooCommerce or Snapshop. Simply enter your store's URL, authorize the connection, and seamlessly integrate with {{appName}} to start your Print On Demand business.`,
    "STORES-SETTING-SELECT-MODE-SHOPIFY-DESCRIPTION": `The Shopify App provides a connection between your Shopify Store and the {{appName}} Print On Demand Service. This integration enables you to sell customized products through our platform. `,
    "STORES-SETTING-SELECT-MODE-API": 'Api Integration',
    "STORES-SETTING-SELECT-MODE-SHOPIFY": 'Shopify',
    "STORES-SETTING-SELECT-MODE-API-DESCRIPTION": `The API offers a seamless connection between your e-commerce
    platforms, services, or own stores, allowing you to sell products that you've customized on our
    platform or enable your customers to apply their own customization to the
    products you sell.`,
    "STORES-SETTING-SELECT-MODE-BUTTON-CONNECT-THE-SHOP": 'CONNECT THE SHOP',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-TITLE": 'Create Snap Shop',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-QP": 'qpmarkets',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-DESCRIPTION": `is {{appName}}'s partner service that offers you an easy way
    to set up and host your ecommerce store`,
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-1": '1. Click the "CREATE YOUR SNAP SHOP NOW" button to go to qpmarkets.',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-2": '2. If you have an account, login to qpmarkets, otherwise regist an new account on qpmarkets.',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-CONTENT-3": '3. Create a new subsite on qpmarkets.',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON": 'CREATE YOUR SNAP SHOP NOW',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-ALREADY-HAVE": 'I already have a snap shop',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-NOTICE": 'Notice: Please make sure your site name is the same as the site name of snap shop.',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-SITE": 'Site Name',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-SITE-TIPS": 'invalid name',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-URL": 'Store URL',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-URL-TIPS": 'invalid url',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON-NEXT": 'Next',
    "STORES-SETTING-SELECT-MODE-SNAP-SHOP-BUTTON-DRAFT": 'Save as draft',
    "STORES-SETTING-SELECT-MODE-MANUAL-STORE": 'Order Import Hub',
    "STORES-SETTING-SELECT-MODE-MANUAL-STORE-DESCRIPTION": "Allows you to create products and place orders without a connected store. Upload your product details and send orders via Excel to {{appName}} for easy management and fulfillment. Ideal for flexible, manual order processing.",
    "STORES-SETTING-MANUAL-SHOP-TITLE": "Store Information",
    "STORES-SETTING-MANUAL-SHOP-STORE-NAME": "Store Name",
    "STORES-SETTING-MANUAL-SHOP-STORE-NAME-PLACEHOLDER": "Order Import Hub Store Name",
    "STORES-SETTING-MANUAL-SHOP-STORE-URL": "Store URL",
    "STORES-SETTING-MANUAL-SHOP-STORE-BUTTON": "Next",
    "STORES-SETTING-NAME-REQUIRED-TIPS":"store name is required",
    "STORES-SETTING-NAME-USED-TIPS": "stroe name already exists ",
    "STORES-SETTING-URL-ILLEGAL-TIPS": "Please enter the correct store url",
    "STORES-SETTING-URL-USED-TIPS": "store url already exists ",
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-3000608": "Your store's currency is not supported.",
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-URL": "to change your store's default currency.",
    "STORES-SETTING-NOT-SUPPORT-CURRENCY-URL-TO": "Click here",
    "STORES-SETTING-CURRENCY-3000607": "The product currency differs from your store's currency.",
    "STORES-SETTING-CURRENCY-3000607-URL-TO": "Click here",
    "STORES-SETTING-CURRENCY-3000607-URL": "to update your currency and pricing.",
    "STORES-SETTING-DEFAULT-CURRENCY-INPUT-TITLE": "Default currency:",
    "STORES-SETTING-DEFAULT-CURRENCY-TITLE": "Currency",
    "STORES-SETTING-DEFAULT-CURRENCY-EDIT": "Edit",
    "STORES-SETTING-DEFAULT-CURRENCY-TIP": "Tip: Please re-confirm the product price after updating the default currency to ensure accuracy.",
    "STORES-CONTENT-TABLE-HEADER-NAME-CURRENCY":"Currency",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY":"Synchronize default currency from your e-shop",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-TITLE-300310": "Store Synchronization Failed",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-CONTENT-300310": "The default currency on your store is not supported. Please update your default currency settings to continue with synchronization.",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-TITLE-300328": "Store Synchronization Failed",
    "STORES-CONTENT-SYNCHRONIZE-CURRENCY-FAILED-CONTENT-300328": "The authentication information configured by the current store cannot be accessed by {{appName}}. Please verify and update your store's authentication settings to proceed with synchronization.",
    "STORES-CONTENT-AUTHORIZATION-ALREADY": "Your authorization has expired. Please click the link below to reauthorize your account:",
    "STORES-CONTENT-AUTHORIZATION-WILL": "Your authorization is about to expire. Please click the link below to reauthorize your account:",
    "STORES-CONTENT-AUTHORIZATION-URL": "Authorized URL >>",

};

export { language }